<template>
  <NdsDropdown
    v-if="routesWheel && routesWheel.length > 0"
    :max-height="600"
    :placement="NdsPopoverPlacement.BOTTOM_END"
  >
    <template #trigger>
      <NdsButton
        :color="NdsButtonColor.TERTIARY"
        data-testid="toggle-wheel-menu"
        :size="NdsButtonSize.S"
      >
        <NdsIcon
          :icon="NdsIconType.SETTINGS"
          :size="NdsIconSize.S"
        />
      </NdsButton>
    </template>

    <template #dropdownContent>
      <NdsMenuItem
        v-for="routeWheel in routesWheel"
        :key="routeWheel.name"
        :data-testid="routeWheel.meta.title"
        :is-checkable="false"
        :value="isActive(routeWheel)"
        @click.native="emit('refresh', $event, routeWheel)"
      >
        <template #label>
          <div class="adminWheelDropdown__item">
            <AppIcon
              class="adminWheelDropdown__itemIcon"
              color="primary"
              :custom_icon="routeWheel.meta.icon"
              fa_type="far"
              icon_size="1rem"
            />
            <span>
              <template v-if="routeWheel.meta.i18nTitle">{{ t(routeWheel.meta.i18nTitle) }}</template>
              <translate v-else>{{ routeWheel.meta.title }}</translate>
            </span>
          </div>
        </template>
      </NdsMenuItem>
    </template>
  </NdsDropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import AppIcon from '@/components/ui/AppIcon.vue'
import NdsButton from '@/components/NewDesignSystem/NdsButton/NdsButton.vue'
import NdsIcon from '@/components/NewDesignSystem/NdsIcon/NdsIcon.vue'
import { NdsIconSize, NdsIconType } from '@/components/NewDesignSystem/NdsIcon/NdsIcon.interfaces'
import NdsDropdown from '@/components/NewDesignSystem/NdsDropdown/NdsDropdown.vue'
import NdsMenuItem from '@/components/NewDesignSystem/NdsMenuItem/NdsMenuItem.vue'
import { NdsButtonColor, NdsButtonSize } from '@/components/NewDesignSystem/NdsButton/NdsButton.interfaces'
import { t } from '@/I18n'
import { isWheelRoute } from '@/components/layout/main-header/connected/AdminWheelDropdown.helpers'
import type { WheelRoute } from '@/components/layout/main-header/connected/AdminWheelDropdown.interfaces'
import { NdsPopoverPlacement } from '@/components/NewDesignSystem/NdsPopover/NdsPopover.interfaces'

const router = useRouter()
const route = useRoute()

const emit = defineEmits<(e: 'refresh', event: MouseEvent, routeWheel: WheelRoute) => void>()

const routesWheel = computed<WheelRoute[]>(() => {
  const wheelMainRoute = router.options.routes?.find((e) => e.path === '/admin')
  if (!wheelMainRoute?.children) {
    return []
  }
  return wheelMainRoute.children.filter((e): e is WheelRoute => isWheelRoute(e) && e.meta.is_authorized(e) !== false)
})

const isActive = (routeWheel: WheelRoute) => {
  return route.matched.some((r) => r.name === routeWheel.name)
}
</script>

<style lang="scss" scoped>
.adminWheelDropdown {
  &__triggerIcon {
    font-size: 20px !important;
    pointer-events: none;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__itemIcon {
    margin-right: 0 !important;
  }
}
</style>
